import React from 'react';
import './ResultModal.css';

function ResultModal({ wordCount, mistakes, time, onRestart, onNext }) {
  const accuracy = Math.max(0, Math.round(((wordCount - mistakes) / wordCount) * 100));
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  
  const getStars = () => {
    if (accuracy >= 95) return 3;
    if (accuracy >= 80) return 2;
    return 1;
  };
  
  const stars = getStars();

  return (
    <div className="result-modal-overlay">
      <div className="result-modal">
        <h2 className="result-title">완료!</h2>
        
        <div className="result-stars">
          {[1, 2, 3].map((star) => (
            <span 
              key={star} 
              className={`star ${star <= stars ? 'filled' : ''}`}
            >
              ⭐
            </span>
          ))}
        </div>

        <div className="result-stats">
          <div className="stat-item">
            <span className="stat-label">단어 수</span>
            <span className="stat-value">{wordCount}개</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-label">정확도</span>
            <span className="stat-value">{accuracy}%</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-label">소요 시간</span>
            <span className="stat-value">
              {minutes > 0 && `${minutes}분 `}{seconds}초
            </span>
          </div>
        </div>

        <div className="result-message">
          {accuracy >= 95 && "완벽해요! 정말 잘했어요!"}
          {accuracy >= 80 && accuracy < 95 && "잘했어요! 조금만 더 연습해봐요!"}
          {accuracy < 80 && "괜찮아요! 다시 한 번 도전해봐요!"}
        </div>

        <div className="result-actions">
          <button className="btn btn-secondary" onClick={onRestart}>
            다시하기
          </button>
          <button className="btn btn-primary" onClick={onNext}>
            메인으로
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResultModal;